var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-column relative" },
    [
      _c(
        "el-table",
        {
          class: _vm.listingClasses,
          staticStyle: { width: "100%" },
          attrs: { data: _vm.rows, border: "", height: "100%" },
          on: { "sort-change": _vm.sendOrder }
        },
        [
          _vm.mainColumn
            ? _c("el-table-column", {
                key: _vm.mainColumn.name,
                attrs: {
                  fixed: "",
                  sortable: _vm.mainColumn.sortable === true ? "custom" : false,
                  "sort-method": _vm.sortColumn,
                  prop: _vm.mainColumn.name,
                  label: _vm.mainColumn.label,
                  "show-overflow-tooltip": "",
                  "min-width": _vm.convertedWidth(_vm.mainColumn.width)
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("div", {
                            staticClass: "subcell semibold",
                            domProps: {
                              innerHTML: _vm._s(
                                scope.row["formatted_" + _vm.mainColumn.name] !=
                                  undefined
                                  ? scope.row[
                                      "formatted_" + _vm.mainColumn.name
                                    ]
                                  : scope.row[_vm.mainColumn.name]
                              )
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  99546718
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.commonColumns, function(header, index) {
            return _c("el-table-column", {
              key: "header-" + header.name + "-" + header.rank,
              attrs: {
                fixed: index == 0,
                prop: header.name,
                label: header.label,
                "render-header": _vm.labelTooltiped,
                "sort-by": header.name,
                "show-overflow-tooltip": "",
                sortable: header.sortable === true ? "custom" : false,
                "sort-method": _vm.sortColumn,
                width: _vm.convertedWidth(header.width)
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row["formatted_" + header.name] != undefined
                          ? [
                              typeof scope.row["formatted_" + header.name] ==
                                "object" &&
                              scope.row["formatted_" + header.name].type ==
                                "component"
                                ? [
                                    _c(
                                      scope.row["formatted_" + header.name]
                                        .name,
                                      _vm._b(
                                        {
                                          key: header.name + "_" + scope.row.id,
                                          tag: "component"
                                        },
                                        "component",
                                        scope.row["formatted_" + header.name]
                                          .params,
                                        false
                                      )
                                    )
                                  ]
                                : _c("div", {
                                    staticClass: "subcell",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        scope.row["formatted_" + header.name]
                                      )
                                    }
                                  })
                            ]
                          : [_vm._v(_vm._s(scope.row[header.name]))]
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: {
                label: _vm.$t.__("accounting.AgedBalanceTable.to_expire")
              }
            },
            _vm._l(_vm.amountToGoColumns, function(header) {
              return _c("el-table-column", {
                key: "header-" + header.name + "-" + header.rank,
                attrs: {
                  prop: header.name,
                  label: header.label,
                  "render-header": _vm.labelTooltiped,
                  "sort-by": header.name,
                  "show-overflow-tooltip": "",
                  sortable: header.sortable === true ? "custom" : false,
                  "sort-method": _vm.sortColumn,
                  width: _vm.convertedWidth(header.width)
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row["formatted_" + header.name] != undefined
                            ? [
                                typeof scope.row["formatted_" + header.name] ==
                                  "object" &&
                                scope.row["formatted_" + header.name].type ==
                                  "component"
                                  ? [
                                      _c(
                                        scope.row["formatted_" + header.name]
                                          .name,
                                        _vm._b(
                                          {
                                            key:
                                              header.name + "_" + scope.row.id,
                                            tag: "component"
                                          },
                                          "component",
                                          scope.row["formatted_" + header.name]
                                            .params,
                                          false
                                        )
                                      )
                                    ]
                                  : _c("div", {
                                      staticClass: "subcell",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          scope.row["formatted_" + header.name]
                                        )
                                      }
                                    })
                              ]
                            : [_vm._v(_vm._s(scope.row[header.name]))]
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: { label: _vm.$t.__("accounting.AgedBalanceTable.expired") }
            },
            _vm._l(_vm.amountExpiredColumns, function(header) {
              return _c("el-table-column", {
                key: "header-" + header.name + "-" + header.rank,
                attrs: {
                  prop: header.name,
                  label: header.label,
                  "render-header": _vm.labelTooltiped,
                  "sort-by": header.name,
                  "show-overflow-tooltip": "",
                  sortable: header.sortable === true ? "custom" : false,
                  "sort-method": _vm.sortColumn,
                  width: _vm.convertedWidth(header.width)
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row["formatted_" + header.name] != undefined
                            ? [
                                typeof scope.row["formatted_" + header.name] ==
                                  "object" &&
                                scope.row["formatted_" + header.name].type ==
                                  "component"
                                  ? [
                                      _c(
                                        scope.row["formatted_" + header.name]
                                          .name,
                                        _vm._b(
                                          {
                                            key:
                                              header.name + "_" + scope.row.id,
                                            tag: "component"
                                          },
                                          "component",
                                          scope.row["formatted_" + header.name]
                                            .params,
                                          false
                                        )
                                      )
                                    ]
                                  : _c("div", {
                                      staticClass: "subcell",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          scope.row["formatted_" + header.name]
                                        )
                                      }
                                    })
                              ]
                            : [_vm._v(_vm._s(scope.row[header.name]))]
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            }),
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }